// vendor modules
import { connect } from "react-redux"

// internal modules
import Filter from "search-new/components/Filter/index"

const mapStateToProps = (state, props) => ({})

const actions = {}

export default connect(mapStateToProps, actions)(Filter)
